module.exports = "/packs/media/images/strategy-spending-86dfe469e8acb2e9cef5d0633414c25e.png";